import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Prism from 'prismjs';
import { SharedService } from 'src/app/shared/shared.service';

import { AbstractListComponent } from '../../../../model/AbstractListComponent';
import {
  ListProveFinaliDTO,
  ProvaFinaleDTO,
  SelectDTO,
} from './../../../../model/newModel';
import { AProvaFinaleService } from './../a-prova-finale.service';

@Component({
  selector: 'app-list-prove-finali',
  templateUrl: './list-prove-finali.component.html',
  styleUrls: ['./list-prove-finali.component.css'],
})
export class ListProveFinaliComponent
  extends AbstractListComponent
  implements AfterViewInit, OnInit {
  listProveFinali: ListProveFinaliDTO;
  tipologieAbilitatoDisabilitato: SelectDTO[];
  abilitatoDisabilitato: string;
  tempListProveFinali: ProvaFinaleDTO[];
  showProveFinali: boolean;

  ngOnInit(): void {
    this.tipologieAbilitatoDisabilitato = this.sharedService.allSelectTipologieAbilitatoDisabilitato();
    super.ngOnInit();
    this.getList(this.abilitatoDisabilitato);
  }

  elimina(idProvaFinale: number) {
    this.aProvaFinaleService.searchPrenotati(idProvaFinale).subscribe(
      (result) => {
        if (
          !!result.prenotatiProveFinali &&
          result.prenotatiProveFinali.length > 0
        ) {
          this.spinner.hide();
          const text =
            'la prova finale non può essere eliminata perchè ha studenti associati';
          this.sharedService.openWarningModal(text);
        } else {
          this.aProvaFinaleService.delete(idProvaFinale).subscribe(
            (result2) => {
              if (result2) {
                this.sharedService.openOkModal();
                this.modalSubscribe = this.ngxSmartModalService
                  .getModal('okModal')
                  .onClose.subscribe((modal: NgxSmartModalComponent) => {
                    this.getList(this.abilitatoDisabilitato);
                  });
              } else {
                this.sharedService.openKoModal();
              }
              this.spinner.hide();
            },
            (error) => {
              this.spinner.hide();
              console.log('Errore elimina');
            }
          );
        }
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore searchPrenotati');
      }
    );
  }

  getList(abilitatoDisabilitato: string) {
    this.spinner.show();
    this.aProvaFinaleService.search(abilitatoDisabilitato).subscribe(
      (result) => {
        this.listProveFinali = result;
        this.calcolaListVaiA(this.listProveFinali.pages);
        this.idVaiA = '' + (this.listProveFinali.currentPage - 1);
        if (this.listProveFinali.proveFinali.length > 0) {
          this.showProveFinali = true;
        } else {
          this.showProveFinali = false;
        }
        this.tempListProveFinali = Object.assign(
          [],
          this.listProveFinali.proveFinali
        );
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore search');
      }
    );
  }

  downloadPrenotati(idProvaFinale: number, data: Date) {
    this.spinner.show();
    this.aProvaFinaleService.downloadPrenotati(idProvaFinale).subscribe(
      (result) => {
        const downloadURL = window.URL.createObjectURL(result);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'prenotati_prova_finale_' + data + '.csv';
        link.click();
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore prova:' + error);
        this.spinner.hide();
      }
    );
  }

  aggiungiStudente(provaFinale: ProvaFinaleDTO) {
    this.ngxSmartModalService
      .getModal('addStudentProvaFinaleModal')
      .removeData();
    this.ngxSmartModalService.setModalData(
      provaFinale,
      'addStudentProvaFinaleModal'
    );
    this.ngxSmartModalService.getModal('addStudentProvaFinaleModal').open();
  }

  goToEditDetail(id: number) {
    this.router.navigate(['/a-prova-finale/modifica'], {
      queryParams: { idProvaFinale: id },
    });
  }

  disabilita(id: number) {
    this.aProvaFinaleService
      .abilitaDisabilita(id, false)
      .subscribe((result) => {
        if (result) {
          this.sharedService.openOkModal();
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              this.getList(this.abilitatoDisabilitato);
            });
        }
      });
  }

  disabilitaAbilita(id: number, value: boolean) {
    if (value) {
      this.disabilita(id);
    } else {
      this.abilita(id);
    }
  }

  abilita(id: number) {
    this.aProvaFinaleService.abilitaDisabilita(id, true).subscribe((result) => {
      if (result) {
        this.sharedService.openOkModal();
        this.modalSubscribe = this.ngxSmartModalService
          .getModal('okModal')
          .onClose.subscribe((modal: NgxSmartModalComponent) => {
            this.getList(this.abilitatoDisabilitato);
          });
      }
    });
  }

  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private aProvaFinaleService: AProvaFinaleService
  ) {
    super();
  }

  nextPage(skip: number, take: number, count: number) {
    this.spinner.show();
    this.aProvaFinaleService
      .nextPage(this.abilitatoDisabilitato, skip, take, count)
      .subscribe(
        (result) => {
          this.listProveFinali = result;
          this.calcolaListVaiA(this.listProveFinali.pages);
          this.idVaiA = '' + (this.listProveFinali.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search next');
          this.spinner.hide();
        }
      );
  }

  goToPage(idVaiA: string, event: any) {
    this.spinner.show();
    this.aProvaFinaleService
      .goToPage(this.abilitatoDisabilitato, idVaiA, this.listProveFinali.take)
      .subscribe(
        (result) => {
          this.listProveFinali = result;
          this.calcolaListVaiA(this.listProveFinali.pages);
          this.idVaiA = '' + (this.listProveFinali.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search goToPage');
          this.spinner.hide();
        }
      );
  }

  previousPage(skip: number, take: number) {
    this.spinner.show();
    this.aProvaFinaleService
      .previousPage(this.abilitatoDisabilitato, skip, take)
      .subscribe(
        (result) => {
          this.listProveFinali = result;
          this.calcolaListVaiA(this.listProveFinali.pages);
          this.idVaiA = '' + (this.listProveFinali.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search previous');
          this.spinner.hide();
        }
      );
  }
}
